<template>
  <button @click="open" class="btn btn-sm btn-info mr-1 mb-1">
    <font-awesome-icon icon="arrow-right"/>&nbsp;{{ $t('title') }}
    <b-modal v-model="showForm" no-close-on-backdrop no-enforce-focus :title="$t('title')">
      <div class="alert alert-info" v-html="$t('guide')"></div>
      <admin-user-select :label="$t('fromUser')" :status="null" :model="formModel" attribute="fromUser" :errors="formErrors"></admin-user-select>
      <admin-user-select :label="$t('toUsers')" multiple :model="formModel" attribute="toUsers" :errors="formErrors"></admin-user-select>
      <form-select :label="$t('status')" :model="formModel" attribute="status" :options="statusOptions"
                   :errors="formErrors"></form-select>
      <div class="text-muted small">{{ $t('statusGuide') }}</div>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button class="btn btn-primary" @click="change()">
          {{ $t('change') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
  import AdminUserSelect from "../../components/AdminUserSelect";
  export default {
    components: {AdminUserSelect},
    data() {
      return {
        showForm: false,
        formModel: {
          role: 'bd',
          fromUser: null,
          toUsers: [],
          status: 'all'
        },
        formErrors: []
      }
    },
    computed: {
      // Giá trị khớp whitelist CHANGE_ROLE_STATUSES ở BE (routes/client.js)
      statusOptions() {
        return [
          {value: 'all', text: this.$t('statusAll')},
          {value: 'active', text: this.$t('statusActive')},
          {value: 'expired', text: this.$t('statusExpired')},
          {value: 'trial', text: this.$t('statusTrial')}
        ]
      }
    },
    methods: {
      open() {
        this.formModel = {role: 'bd', fromUser: null, toUsers: [], status: 'all'};
        this.formErrors = [];
        this.showForm = true
      },
      change() {
        this.$swal({
          title: this.$t('changeConfirm'),
          icon: "warning",
          showCancelButton: true
        }).then((result) => {
          if (result.value) {
          let loader = this.$loading.show();
          this.$service({
              url: '/client/change-role',
              method: 'post',
              // bỏ chọn hết nhân viên đích = thu hồi khách, phải gửi mảng rỗng chứ không phải null
              data: Object.assign({}, this.formModel, {toUsers: this.formModel.toUsers || []})
            }).then(response => {
              this.showForm = false;
              if (response.data) {
                // BE trả {success, count, unsynced}; API cũ trả true — vẫn hiển thị được cả 2 dạng
                let count = response.data && typeof response.data.count === 'number' ? response.data.count : null;
                // Nhân viên chưa có tài khoản Callio nội bộ: khách đã chuyển xong, chỉ thiếu bước
                // gán người phụ trách bên CRM nội bộ — báo để admin biết mà tạo tài khoản, không phải lỗi
                let unsynced = (response.data && response.data.unsynced) || [];
                // nối bằng khoảng trắng, không dùng \n — swal render text trong thẻ thường,
                // xuống dòng phụ thuộc CSS nên dễ dính liền chữ
                let text = count === null ? this.$t('changeSuccess') : this.$t('changeSuccessCount', {count: count});
                if (unsynced.length) {
                  text += ' ' + this.$t('unsyncedWarn', {names: unsynced.join(', ')});
                }
                this.$swal({
                    title: this.$t('success'),
                    text: text,
                    icon: unsynced.length ? 'warning' : 'success'
                });
                this.$bus.$emit('loadClient');
              } else {
                this.$swal({
                    title: this.$t('error'),
                    text: this.$t('changeFailed'),
                    icon: 'error'
                });
              }
            }).catch(error => {
              let data = error.response ? error.response.data : null;
              if (!data) {
                this.$swal({
                  text: this.$t('changeFailed'),
                  icon: 'error'
                });
              } else if (data.message) {
                this.$swal({
                  text: data.message,
                  icon: 'error'
                });
                this.showForm = false;
              } else {
                this.formErrors = data;
              }
            }).finally(() => {
              loader.hide();
            });
          }
        })
      },
    },
    i18n: {
      messages: {
        en: {
          guide: "Clients will be divided evenly among the selected users. If none is selected, clients will be unassigned",
          change: "Change",
          title: "Change Sales",
          fromUser: "From user",
          toUsers: "To users",
          changeConfirm: "Are you sure you want to make this change?",
          changeSuccess: "Change success",
          changeSuccessCount: "Change success — {count} client(s) updated",
          unsyncedWarn: "Note: {names} has no internal Callio account yet, so the assignee on the internal CRM customer record was not updated. To sync later, create the account then run this change again with that same person in BOTH fields (from them, to them).",
          changeFailed: "Change failed",
          status: "Client status",
          statusGuide: "Only clients matching the selected status will be reassigned",
          statusAll: "All",
          statusActive: "Active",
          statusExpired: "Expired",
          statusTrial: "Trial"
        },
        vi: {
          guide: "Khách hàng sẽ được chia đều cho các nhân viên đã chọn. Nếu không chọn, hệ thống sẽ thu hồi khách hàng",
          change: "Thay đổi",
          title: "Thay đổi Sales",
          fromUser: "Chuyển từ nhân viên",
          toUsers: "Tới các nhân viên",
          changeConfirm: "Bạn có chắc chắn muốn thực hiện thay đổi này?",
          changeSuccess: "Thay đổi thành công",
          changeSuccessCount: "Thay đổi thành công — đã cập nhật {count} khách hàng",
          unsyncedWarn: "Lưu ý: {names} chưa có tài khoản Callio nội bộ nên chưa cập nhật được người phụ trách trên hồ sơ khách bên CRM nội bộ. Khách hàng vẫn đã chuyển đúng. Muốn đồng bộ nốt thì tạo tài khoản cho nhân viên rồi chạy lại lệnh này với chính nhân viên đó ở CẢ HAI ô (chuyển từ họ, tới họ).",
          changeFailed: "Thay đổi thất bại",
          status: "Trạng thái khách hàng",
          statusGuide: "Chỉ những khách hàng thoả trạng thái đã chọn mới được thay đổi sales",
          statusAll: "Tất cả",
          statusActive: "Đang hoạt động",
          statusExpired: "Hết hạn",
          statusTrial: "Dùng thử"
        }
      }
    }
  }
</script>
